import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTranslation } from "react-i18next";
const ValidationErrorTable = ({ errors }) => {

    const { t } = useTranslation();

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
         
                <TableBody>
                <TableRow>
                        <TableCell>{t('cellAddress')}</TableCell>
                        <TableCell >{t('headerName')}</TableCell>
                        <TableCell>{t('error')}</TableCell>
                    </TableRow>
                    {errors.map((error, index) => (
                       
                                <TableRow
              key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                           <TableCell align="left">{error.cellAddress}</TableCell>
                            <TableCell align="left">{error.headerName}</TableCell>
                            <TableCell align="left">{ t(error.error)}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
    

};

export default ValidationErrorTable;
